import { Fade, Typography } from '@material-ui/core'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Currency } from '../../types/currency'
import { WalletTransaction } from '../../types/walletTransaction'
import { TransactionListRow } from './TransactionListRow'
import useStyles from './styles/TransactionList.styles'

interface TransactionListProps {
  transactions: WalletTransaction[]
  currency: Currency
}
const TransactionList: React.FC<TransactionListProps> = ({
  transactions,
  currency
}) => {
  const classes = useStyles()

  return (
    <div>
      <SectionTitle title="Transaction List" marginBottom />
      <div className={classes.tableHeadWithoutCreditor}>
        <div>
          <Typography variant="body1">#</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Date')}</Typography>
        </div>

        <div>
          <Typography variant="body1">{getTranslate('R.N')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Amount')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Payment Due')}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Penalty/Bounce')}
          </Typography>
        </div>
      </div>
      <div className={classes.rowsContainer}>
        {transactions
          .filter((transaction) => transaction.type !== 'penalty')
          .map((singleTransaction: WalletTransaction, index: number) => (
            <Fade in timeout={600} key={singleTransaction.transactionID}>
              <div>
                <TransactionListRow
                  data={singleTransaction}
                  index={index}
                  currency={currency}
                />
              </div>
            </Fade>
          ))}
      </div>
    </div>
  )
}

export default TransactionList
